import { NuqsAdapter } from "nuqs/adapters/next/app"

import "./globals.css"

import { Libre_Baskerville, Work_Sans } from "next/font/google"

const workSans = Work_Sans({
  subsets: ["latin"],
  weight: ["400", "500", "600", "700"],
  display: "swap",
  variable: "--work-sans",
})

const libreBaskerville = Libre_Baskerville({
  subsets: ["latin"],
  weight: ["400", "700"],
  display: "swap",
  variable: "--libre-baskerville",
})

import type { Metadata } from "next"
import { Suspense } from "react"
import { BottomNavigation } from "@/components/shared/bottom-navigation"
import { Footer } from "@/components/shared/footer"
import { Header } from "@/components/shared/header"
import { RouteBreadcrumb } from "@/components/shared/route-breadcrumb"
import { Toaster } from "@/components/ui/sonner"
import { QueryProvider } from "@/providers"
import { cn } from "@/utilities"
import { generateMetadataForPath } from "@/utilities/seo"
import { Skeleton } from "~/components/ui/skeleton"

export async function generateMetadata(): Promise<Metadata> {
  const metadata = await generateMetadataForPath("/")

  return metadata
}

export default function RootLayout({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <html
      className={cn(workSans.variable, libreBaskerville.variable)}
      lang='pt-BR'
    >
      <body className='flex min-h-screen flex-col items-center bg-zinc-100'>
        <QueryProvider>
          <Header />
          <div className='flex w-full max-w-6xl flex-col pt-8 pb-[calc(72px+env(safe-area-inset-bottom))] md:py-8'>
            <div className='mb-4 w-full px-4 md:px-0'>
              <Suspense fallback={<Skeleton className='h-6 w-20' />}>
                <RouteBreadcrumb />
              </Suspense>
            </div>
            <NuqsAdapter>{children}</NuqsAdapter>
          </div>
          <Suspense fallback={null}>
            <Footer />
          </Suspense>
          <Suspense fallback={null}>
            <BottomNavigation />
          </Suspense>
          <Toaster position='top-right' />
        </QueryProvider>
      </body>
    </html>
  )
}
